module.exports = __webpack_public_path__ + "img/Syrenis-Black.144ba54a.svg";